import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Shield, FileText, Cookie } from 'lucide-react';

const LegalPage = ({ type }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [type]);

    const content = {
        'privacy-policy': {
            title: 'Privacy Policy',
            icon: Shield,
            lastUpdated: 'February 23, 2026',
            sections: [
                {
                    heading: '1. Information We Collect',
                    text: 'We collect information you provide directly to us, such as when you create an account, subscribe to our newsletter, or contact us for support. This may include your name, email address, and any other information you choose to provide.'
                },
                {
                    heading: '2. How We Use Your Information',
                    text: 'We use the information we collect to provide, maintain, and improve our services, to develop new ones, and to protect Mini App Tech and our users.'
                },
                {
                    heading: '3. Information Sharing',
                    text: 'We do not share your personal information with companies, organizations, or individuals outside of Mini App Tech except in the cases of consent, external processing, or for legal reasons.'
                }
            ]
        },
        'terms-of-service': {
            title: 'Terms of Service',
            icon: FileText,
            lastUpdated: 'February 23, 2026',
            sections: [
                {
                    heading: '1. Acceptance of Terms',
                    text: 'By accessing or using our services, you agree to be bound by these Terms of Service. If you do not agree to these terms, do not use our services.'
                },
                {
                    heading: '2. Use of Services',
                    text: 'You may use our services only as permitted by law and these terms. We may suspend or stop providing our services to you if you do not comply with our terms or policies.'
                },
                {
                    heading: '3. Intellectual Property',
                    text: 'All content included on our services is the property of Mini App Tech or its content suppliers and protected by international copyright laws.'
                }
            ]
        },
        'cookie-policy': {
            title: 'Cookie Policy',
            icon: Cookie,
            lastUpdated: 'February 23, 2026',
            sections: [
                {
                    heading: '1. What Are Cookies',
                    text: 'Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work or work more efficiently.'
                },
                {
                    heading: '2. How We Use Cookies',
                    text: 'We use cookies to understand how you use our website and to improve your experience. This includes keeping you logged in and remembering your preferences.'
                },
                {
                    heading: '3. Managing Cookies',
                    text: 'Most web browsers allow you to control cookies through their settings preferences. However, if you limit the ability of websites to set cookies, you may worsen your overall user experience.'
                }
            ]
        }
    };

    const currentContent = content[type] || content['privacy-policy'];
    const Icon = currentContent.icon;

    return (
        <div className="pt-24 min-h-screen bg-white">
            <section className="py-20 bg-dark text-white relative overflow-hidden">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        className="text-center"
                    >
                        <div className="inline-block p-4 bg-primary/20 rounded-2xl mb-6">
                            <Icon size={40} className="text-primary" />
                        </div>
                        <h1 className="text-4xl md:text-6xl font-bold mb-4">{currentContent.title}</h1>
                        <p className="text-gray-400">Last Updated: {currentContent.lastUpdated}</p>
                    </motion.div>
                </div>
            </section>

            <section className="py-20">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.2 }}
                        className="space-y-12"
                    >
                        {currentContent.sections.map((section, idx) => (
                            <div key={idx}>
                                <h2 className="text-2xl font-bold text-dark mb-4">{section.heading}</h2>
                                <p className="text-gray-600 leading-relaxed text-lg">{section.text}</p>SectionHeader
                            </div>
                        ))}
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default LegalPage;
